module.exports = __webpack_public_path__ + "static/media/Xr_aviation_portfolio_image.a32288b1.jpg";